export const useConquestMutator = <TResult, Variables>(func: (args: Variables) => Promise<TResult>) => {
    return func;
};
